export var TreeNodeType;
(function (TreeNodeType) {
    TreeNodeType["Protein"] = "protein";
    TreeNodeType["Nucleic"] = "nucleic";
    TreeNodeType["Compound"] = "compound";
    TreeNodeType["Metal"] = "metal";
    TreeNodeType["Lipid"] = "lipid";
    TreeNodeType["Ions"] = "ions";
    TreeNodeType["Solvent"] = "solvent";
    TreeNodeType["Region"] = "region";
    TreeNodeType["Other"] = "other"; // For things like fpocket volume atoms
})(TreeNodeType || (TreeNodeType = {}));
export var SelectedType;
(function (SelectedType) {
    SelectedType["False"] = "false";
    SelectedType["True"] = "true";
    SelectedType["ChildOfTrue"] = "child_of_true";
})(SelectedType || (SelectedType = {}));
export var RegionType;
(function (RegionType) {
    RegionType["Sphere"] = "Sphere";
    RegionType["Box"] = "Box";
    RegionType["Arrow"] = "Arrow";
    RegionType["Cylinder"] = "Cylinder";
})(RegionType || (RegionType = {}));
export var TreeNodeDataType;
(function (TreeNodeDataType) {
    TreeNodeDataType[TreeNodeDataType["Table"] = 0] = "Table";
    TreeNodeDataType[TreeNodeDataType["Graph"] = 1] = "Graph";
})(TreeNodeDataType || (TreeNodeDataType = {}));
export var TableHeaderSort;
(function (TableHeaderSort) {
    TableHeaderSort[TableHeaderSort["All"] = 0] = "All";
    TableHeaderSort[TableHeaderSort["AllButFirst"] = 1] = "AllButFirst";
    TableHeaderSort[TableHeaderSort["None"] = 2] = "None";
})(TableHeaderSort || (TableHeaderSort = {}));
